import { render, staticRenderFns } from "./OeSuiji.vue?vue&type=template&id=c2257e16&scoped=true&"
import script from "./OeSuiji.vue?vue&type=script&lang=js&"
export * from "./OeSuiji.vue?vue&type=script&lang=js&"
import style0 from "./OeSuiji.vue?vue&type=style&index=0&id=c2257e16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2257e16",
  null
  
)

export default component.exports